export class DiscountModel {
    id: number = 0;
    serial: string = "";
    percent: number = 0;
    productId: number = 0;
    isValid: boolean = true;
    error: string = 'کد تخفیف نامعتبر است';
    
}